import { makeStyles, createStyles } from '@material-ui/core/styles';

import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

const useStyles = makeStyles(() =>
  createStyles({
    menuItem: {
      color: colors.darkGray,
      '&:hover': {
        backgroundColor: colors.overlayHover,
      },
      '&.Mui-selected': {
        color: colors.primary,
        backgroundColor: colors.overlayPrimary,
      },
    },
    itemTextParent: {
      fontSize: fonts.sizes.small,
      letterSpacing: '0.1px',
      lineHeight: '24px',
      fontWeight: fonts.weights.medium,
    },
    itemTextChild: {
      fontSize: fonts.sizes.small,
      letterSpacing: '0.1px',
      lineHeight: '24px',
      fontWeight: fonts.weights.medium,
      marginLeft: '20px',
    },
    divMenuItem: {
      cursor: 'pointer',
    },
    adornment: {
      float: 'left',
    },
  }),
);

export default useStyles;
